export const TABLE_ROW_SIZE = 50;
export const GRID_COLUMN_MIN_WIDTH = 200;
